/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    shape, string, number,
    bool, arrayOf, func, oneOfType,
} from 'prop-types';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import Image from '../../../../common/Image';
import EventDispatcher from '../../../../state/reducers/EventDispatcher';
import { decode as htmlDecode } from '../../../../utils/htmlEntity';
import configENV from '../../../../config';
import { isEmpty } from '../../../../utils/object';

const { PERSIST_KEY } = configENV;

const ProductAddedToCart = ({ recipient, handleGiftListChooseSomethingDifferent, isReadyState }) => {
    if (isEmpty(recipient.cartDetail)) return null;

    const product = recipient.cartDetail;
    const newName = htmlDecode(product.productDetail.name);
    const chooseSomethingDifferentLabel = isReadyState
        ? 'Undo'
        : 'Removing item from cart...';
    const imageURL = product.productDetail.image
        ? product.productDetail.image.replace(/^http[s]?:/, 'https:')
        : '';
    return (
        <>
            <div className="bold margin-bottom">You Have Selected:</div>
            <div className="split">
                <div>
                    <Image className="flex-none" src={imageURL} alt={newName} />
                </div>
                <div className="flex-2">
                    <span className="bold">
                        {newName} ({product.productDetail.sku})
                    </span>
                    <span>
                        {' '}
                        is currently in your cart for {recipient.firstname}{' '}
                        {recipient.lastname}.
                    </span>
                </div>
            </div>
            <div className="align-center margin-top-2x margin-bottom-2x">
                <Button
                    className="buttonHDSecondary choose-something-different-button"
                    onClick={() => handleGiftListChooseSomethingDifferent(recipient)}
                >
                    {chooseSomethingDifferentLabel}
                </Button>
            </div>
        </>
    );
};

ProductAddedToCart.defaultProps = {
    recipient: {},
    handleGiftListChooseSomethingDifferent: '',
};

ProductAddedToCart.propTypes = {
    recipient: shape({
        AddressBookEntryId: string,
        addToCart: string,
        address: shape({
            addressId: string,
            apt: string,
            city: string,
            company: string,
            country: shape({
                id: string,
                name: string,
            }),
            location: shape({
                id: number,
                name: string,
            }),
            state: shape({
                id: string,
                name: string,
            }),
            street: string,
            zipcode: string,
        }),
        addressId: string,
        firstname: string,
        giftArrived: string,
        id: string,
        isNewRecipient: bool,
        lastname: string,
        occasionId: string,
        orderItemId: string,
        products: arrayOf(
            shape({
                content: string,
                crossedPrice: oneOfType([number, string]),
                discountPrice: oneOfType([number, string]),
                id: string,
                image: string,
                name: string,
                parentCatalogEntryId: string,
                partNumber: string,
                price: number,
                seoproductDisplayURL: string,
                sku: string,
                status: string,
            }),
        ),
        type: string,
    }),
    isReadyState: bool.isRequired,
    handleGiftListChooseSomethingDifferent: func,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    // console.log('ProductAddedToCart - newState', newState);
    return {
        isReadyState: newState.isReadyState,
        // recipient: newState.modal.content,
        addToCart:
            typeof newState.modal.content === 'object'
                ? newState.modal.content.addToCart
                : '',
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleGiftListChooseSomethingDifferent: (recipient) => dispatch(EventDispatcher.handleGiftListChooseSomethingDifferent(recipient)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProductAddedToCart);
